import { Directive } from '@angular/core';

@Directive({
  selector: 'xpo-select-three-columns-container, xpoSelectThreeColumnsContainer',
  host: {
    class: 'xpo-Select-threeColumnsContainer',
  },
})
export class XpoSelectThreeColumnsContainer {}
